export enum DecumulationTab {
  Overview = 'Overview',
}
